import { getOrderItems } from './get-order-items';
export const getOrderItemsByRewardIds = (rewardIds) => {
    return getOrderItems().filter(item => item.rewardId && rewardIds.includes(item.rewardId));
};
